<template>
  <CreditInOutDataTable></CreditInOutDataTable>
</template>

<script>
import CreditInOutDataTable from './CreditInOutDataTable.vue';

export default {
  components: { CreditInOutDataTable },
};
</script>